export default __webpack_public_path__ + "static/media/allotments.f6c3b5e4.svg";